import React from "react";
import {
	InputLabel,
	Select,
	FormControl,
	MenuItem,
	FormHelperText,
} from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import {
	EnhancedDropdownThemeWithMargin,
	EnhancedDropdownThemeWithoutMargin,
} from "../../../utils/utils.js";

const EnhancedDropdownComponent = ({
	value,
	handleChange,
	options,
	labelText,
	id,
	disabled = false,
	helperText,
	error = false,
	placeholder,
	required = false,
	inputName = undefined,
	addMarginBottom = true,
	style,
	variant = "outlined",
	...props
}) => {
	return (
		<ThemeProvider
			theme={
				addMarginBottom
					? EnhancedDropdownThemeWithMargin
					: EnhancedDropdownThemeWithoutMargin
			}
		>
			<FormControl
				variant={variant}
				disabled={disabled}
				error={error}
				required={required}
			>
				<InputLabel
					required={required}
					id={`${id}-label`}
					htmlFor={`${id}-selection`}
				>
					{labelText}
				</InputLabel>
				<Select
					labelId={`${id}-label`}
					id={id}
					value={value}
					onChange={handleChange}
					label={required ? `${labelText} *` : labelText}
					displayEmpty={!!placeholder}
					style={style}
					inputProps={{
						id: `${id}-selection`,
		            	name: inputName ?? id
		            }}
			        MenuProps={{ style: { zIndex: 1600 } }}	
					{...props}
				>
					{placeholder && (
						<MenuItem value={0} disabled={required}>
							{placeholder}
						</MenuItem>
					)}

					{options.map(({ key, name }) => (
						<MenuItem key={`${id}-${key}`} value={key}>
							{name}
						</MenuItem>
					))}
				</Select>
				{helperText && (
					<FormHelperText error={error}>{helperText}</FormHelperText>
				)}
			</FormControl>
		</ThemeProvider>
	);
};

export default EnhancedDropdownComponent;
